export default "__VITE_ASSET__CAxqRSLM__"